<!--
    @Author : Luo
    @Time   : 2025/1/17 11:32
-->
<template>
  <div class="client text_left">
    <div class="client_header">
      <div class="client_header_con">
        <div class="client_header_l">
          <span>{{ siteName }}</span>
          <span>引流&咨询服务数据+调研数据</span>
        </div>
        <div class="client_header_r flex_center">
          <div class="client_header_coach">
            <select name="coach" v-model="selectVal">
              <option v-for="c in selectData" :key="'select-' + c.id"  :value="c.id">{{ c.name }}</option>
            </select>
          </div>
          <div class="client_header_date">
            <input type="date" v-model="startDate" name="">
            -
            <input type="date" v-model="endDate" name="">
          </div>
          <div class="client_header_btn">
            <button type="button" @click="getUserInfo">搜索</button>
          </div>
        </div>
      </div>
    </div>

    <el-client :stageData="stageData" :cityData="cityData" :user="userData" :userData="tabUserData" :tabData="tabConsultTypeData" :tabIndex="tabConsultTypeIndex" :consultTypeData="consultTypeData" @update="selectTabHandle" @cat="catInquireDetail" />

    <div class="client_invaild_main flex_center">
      <div :class="{ client_invaild_main_title_act: visibleInvaildInfo, client_invaild_main_title:true, flex_center: true }" @click="visibleInvaildInfo = !visibleInvaildInfo">
        <span>失效</span>
        <template v-if="visibleInvaildInfo">
          <svg-icon iconClass="select_up" className="user_total_inquire_icon pointer_none"></svg-icon>
        </template>
        <template v-else>
          <svg-icon iconClass="select_down" className="user_total_inquire_icon pointer_none"></svg-icon>
        </template>
      </div>
    </div>
    <el-client v-if="visibleInvaildInfo" :stageData="stageData" :cityData="cityData" :user="userData" :userData="tabInvaildUserData" :tabData="tabConsultTypeData" :tabIndex="tabInvaildConsultTypeIndex" :consultTypeData="consultTypeData" @update="selectInvaildTabHandle" @cat="catInquireDetail" />

    <!-- 调研数据 -->
    <div class="dialog_inquire" v-if="visibleDetailInquireData">
      <div class="dialog_inquire_con">
        <div class="dialog_inquire_header">
          <div class="dialog_inquire_title"><span>调研数据</span></div>
          <div class="dialog_inquire_close">
            <svg-icon iconClass="icon_close" className="user_total_inquire_icon svg_icon_14 svg_hover" @svgClick="initInquireDetail"></svg-icon>
          </div>
        </div>
        <div class="dialog_inquire_main">
          <div class="dialog_inquire_table">
            <table>
              <thead class="top_fixed">
                <tr>
                  <th>时间</th>
                  <th>备注</th>
                  <th>状态</th>
                  <th>提交时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="c in detailInquireData" :key="'u-i-' + c.id" :class="c.select ? 'dialog_inquire_select' : ''">
                  <td>{{ setDateType(c.createdAt) }} {{ setDateSecond(c.createdAt) }}</td>
                  <td class="text_ellipsis" :title="c.content">{{ c.content }}</td>
                  <td>
                    <i :class="'dialog_inquire_info_status dialog_inquire_info_tag_' + getInquireStagusVal(c.isComplete).tag" />
                    {{ getInquireStagusVal(c.isComplete).status }}
                  </td>
                  <td>{{ setDateType(c.submitAt) }} {{ setDateSecond(c.submitAt) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _Ajax } from '@/api/_axios'
import { setDateType, setDateSecond } from '@/components/common/common_js'
import { translateData as translateClientData, getClientStatusVal, getStageStatusVal, translateUserData, translateConsultTypeData, isConsultStatus } from './index-client'
import { translateData as translateInquireData, getStagusVal as getInquireStagusVal } from './index-inquire'
import { getCityKey, coachName } from './common'

import elClient from './index-client.vue'

const tempSiteName = '后台 - 工作管理追踪表'

export default {
  name: 'accountAnalysisPage',
  components: {
    elClient
  },
  data () {
    return {
      baseUrl: '',
      startDate: null,
      endDate: null,
      siteName: tempSiteName,

      selectData: [],
      userData: [],
      tabUserData: [],
      originData: [],
      consultTypeData: {},
      stageData: [],
      inquireData: [],
      clientData: [],
      belongData: [],
      allClientSessionData: [],
      clientSessionData: {},
      cityData: {},
      detailInquireData: [],
      visibleDetailInquireData: false,
      visibleInvaildInfo: false,
      tabInvaildUserData: [],
      tabConsultTypeData: [],
      tabConsultTypeIndex: '',
      tabInvaildConsultTypeIndex: '',
      selectVal: '',

      getClientStatusVal: getClientStatusVal,
      getStageStatusVal: getStageStatusVal,
      getInquireStagusVal: getInquireStagusVal,
      setDateType: setDateType,
      setDateSecond: setDateSecond
    }
  },
  methods: {
    getData: async function () {
      const that = this

      try {
        that.originData = await that.getApiData('/client/origin')

        let tempStageData = await that.getApiData('/client/stage')
        if (tempStageData) {
          tempStageData = tempStageData.filter(r => r.isActive === 1)
          that.stageData = tempStageData.sort((a, b) => a.sort - b.sort)
        }

        that.belongData = await that.getApiData('/client/origin/belong')

        const tempConsultTypeData = await that.getApiData('/user/role')
        that.consultTypeData = translateConsultTypeData(tempConsultTypeData)

        await that.getUserInfo()
      } catch (error) {
        console.log('【error:getData】', error)
      }
    },
    // 获取用户信息
    getUserInfo: async function () {
      try {
        const that = this
        this.userData = []
        this.clientSessionData = {}
        that.cityData = {}
        that.allClientSessionData = []

        const tempUserData = await that.getApiData('/user/list')
        that.userData = translateUserData(tempUserData)

        that.clientData = await that.getApiData('/client/info/clients')
        const tempClientSessionData = await that.getApiData('/client/session')
        that.allClientSessionData = tempClientSessionData
        that.getClassigyClientSession(tempClientSessionData)

        that.inquireData = await that.getApiData('/session/category')

        const tempCities = await that.getApiData(`/cities/list`)
        if (tempCities.cities && tempCities.cities.length > 0) {
          for (const item of tempCities.cities) {
            if (!that.cityData[getCityKey(item.code)]) that.cityData[getCityKey(item.code)] = item.name
          }
        }

        await that.getTabUserData(1)
        await that.getTabUserData(0)

        console.log('-------userData-', JSON.parse(JSON.stringify(that.userData)), 'sessi', that.clientSessionData)
      } catch (error) {
        console.log('【error:getUserInfo】', error)
      }
    },
    // 获取tab用户信息
    getTabUserData: async function (vaild) {
      try {
        const that = this
        const tempData = this.userData
        const tempInquireData = that.inquireData
        const tempClientData = that.clientData
        const tempIsConsultStatus = isConsultStatus(vaild)
        const tempIndex = tempIsConsultStatus ? that.tabConsultTypeIndex : that.tabInvaildConsultTypeIndex

        // 清空数据
        if (tempIsConsultStatus) that.tabUserData = []
        else that.tabInvaildUserData = []

        for (const item of tempData) {
          const tempUserClient = tempClientData.filter(i => i.userId === item.id)
          const tempTranslateUserClient = translateClientData(tempUserClient, tempClientData, that.stageData, that.originData, that.belongData, that.clientSessionData, that.allClientSessionData, that.startDate, that.endDate, that.selectVal)

          const tempUserInquire = tempInquireData.filter(i => i.userId === item.id)
          const tempTranslateUserInquire = translateInquireData(tempUserInquire, that.startDate, that.endDate)

          const tempDataItem = {
            ...item,
            ...tempTranslateUserClient,
            ...tempTranslateUserInquire,
            consultType: that.consultTypeData[item.role],
            hidden: false
          }

          const tempIsConsultTypeOther = tempIndex === 'other' && that.tabConsultTypeData.includes(item.role) === false
          if ((item.role === tempIndex || tempIsConsultTypeOther) && item.active === vaild) {
            if (tempIsConsultStatus) that.tabUserData.push(tempDataItem)
            else that.tabInvaildUserData.push(tempDataItem)
          }
        }

        if (tempIsConsultStatus) console.log('有效', JSON.parse(JSON.stringify(that.tabUserData)))
        else console.log('无效', JSON.parse(JSON.stringify(that.tabInvaildUserData)))
      } catch (error) {
        console.log('【error:getTabUserData', error)
      }
    },
    selectTabHandle: function (i) {
      const that = this

      that.tabConsultTypeIndex = i
      that.getTabUserData(1)
    },
    selectInvaildTabHandle: function (i) {
      const that = this

      that.tabInvaildConsultTypeIndex = i
      that.getTabUserData(0)
    },
    // 查看当前调研
    catInquireDetail: function (data) {
      const that = this
      that.detailInquireData = data.sessionInquire
      that.visibleDetailInquireData = true
    },
    // 原始阶段数据归类（客户 -> 阶段1，阶段2...）
    getClassigyClientSession: function (data) {
      const that = this

      for (const item of data) {
        const tempClientSessionKey = item.clientId
        let isExistStage = true
        let replaceClientSession = null

        if (!that.clientSessionData[tempClientSessionKey]) that.clientSessionData[tempClientSessionKey] = []

        if (that.clientSessionData[tempClientSessionKey].length) {
          that.clientSessionData[tempClientSessionKey].forEach((sessionItem, sessionIndex) => {
            // 使用最新的预约时间
            if (item.stageId === sessionItem.stageId) {
              isExistStage = false

              if (item.creatAt > sessionItem.creatAt) replaceClientSession = sessionIndex
            }
          })
        }

        // 替换符合条件的阶段预约数据
        if (!isNaN(parseFloat(replaceClientSession))) that.clientSessionData[tempClientSessionKey][replaceClientSession] = { ...item }

        // 添加阶段预约数据
        if (isExistStage) that.clientSessionData[tempClientSessionKey].push({ ...item })
      }
    },
    getApiData: function (url) {
      const that = this
      return new Promise((resolve, reject) => {
        _Ajax({ baseUrl: that.baseUrl, method: 'get', url: url, clearCancelSource: true }, (res) => { resolve(res.data.data) }, reject)
      })
    },
    initInquireDetail: function () {
      const that = this
      that.detailInquireData = []
      that.visibleDetailInquireData = false
    }
  },
  mounted () {
    document.title = tempSiteName
    const that = this
    const envModule = process.env.ENV_MODULE

    that.baseUrl = envModule === 'development' ? 'https://ind.test.geetecho.com' : 'https://ind.geetecho.com'
    // that.baseUrl = envModule === 'development' ? 'http://localhost:3000' : 'https://ind.geetecho.com'

    that.tabConsultTypeData = ['consult', 'trainee', 'fresh-graduate', 'other']
    that.tabConsultTypeIndex = 'consult'
    that.tabInvaildConsultTypeIndex = 'consult'
    that.selectData = [
      { id: 'all', name: '全部' },
      { id: coachName, name: '带教' }
    ]
    that.selectVal = 'all'

    that.getData()
  }
}
</script>

<style>
body {background: #fff;min-width: unset;overflow: auto}
</style>
<style scoped>
.client {padding: 30px 28px}
.top_fixed {position: sticky;top: 0;z-index: 9}
.left_fixed {position: sticky;left: 0;z-index: 9}

.client_header_con {display: flex;justify-content: space-between;align-items: flex-start}
.client_header_l {display: flex;flex-flow: column}
.client_header_l span:first-of-type {color: #303030;font-size: 24px;font-weight: bold}
.client_header_l span:last-of-type {margin-top: 14px;color: #303030;font-size: 14px;font-weight: #909090}
.client_header_date {margin: 0 16px}
.client_header_date input {border: 1px solid #DBDBDB;border-radius: 4px;height: 32px;width: 200px;outline: none;padding: 0 15px;font-size: 14px}
.client_header_btn button {width: 80px;height: 32px;background: #4C8BFF;border-radius: 4px;outline: none;border: 1px solid #4C8BFF;font-size: 12px;color: #FFFFFF}
.client_header_coach select {border: 1px solid #DBDBDB;border-radius: 4px;height: 32px;width: 200px;outline: none;padding: 0 15px;font-size: 14px}

.client_invaild_main {justify-content: flex-start;padding: 20px 0}
.client_invaild_main_title {cursor: pointer}
.client_invaild_main_title span {font-size: 16px;color: #606060}
.client_invaild_main_title:hover span {color: rgba(76, 139, 255, 1)}
.client_invaild_main_title:hover >>> .user_total_inquire_icon {fill: rgba(76, 139, 255, 1)}
.client_invaild_main_title >>> .user_total_inquire_icon {width: 14px;height: 14px}
.client_invaild_main_title.client_invaild_main_title_act span {color: rgba(76, 139, 255, 1)}
.client_invaild_main_title.client_invaild_main_title_act >>> .user_total_inquire_icon {fill: rgba(76, 139, 255, 1)}

.dialog_inquire {position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .4);width: 100%;height: 100%;z-index: 20}
.dialog_inquire_con {width: 50%;height: 100%;background-color: #FFF;margin-left: auto;padding: 30px}
.dialog_inquire_header {display: flex;align-items: center;justify-content: space-between;padding-bottom: 40px}
.dialog_inquire_main {height: calc(100% - 120px)}
.dialog_inquire_table {height: 100%;overflow: auto}
.dialog_inquire_info_status {display: inline-block;width: 8px;height: 8px;border-radius: 50%}
.dialog_inquire_info_tag_success {background-color: #12BF26}
.dialog_inquire_info_tag_planning {background-color: #4C8BFF}
.dialog_inquire_select {background-color: rgba(18, 191, 38, .1)}
.dialog_inquire_table table {width: 100%}
.dialog_inquire_table thead th {background-color: #f8f8f9;min-width: 170px;max-width: 170px;padding-left: 10px}
.dialog_inquire_table tbody td {min-width: 170px;max-width: 170px;padding-left: 10px}
.dialog_inquire_table thead tr {line-height: 50px}
.dialog_inquire_table tbody tr {line-height: 32px}
.dialog_inquire_table tr {font-size: 14px;border-bottom: 1px solid #ebebeb}
</style>



// WEBPACK FOOTER //
// src/components/page-client/index.vue